<template>
    <div class="media-share-login">
        <layout>
            <div class="d-flex flex-column justify-content-center align-items-center h-100">
                <div class="d-flex flex-row justify-content-center mb-4">
                    <img class="mr-4" :src="client.logo_url" width="24" height="24" :alt="client.name">
                    <span class="project-name">{{ project.name }}</span>
                </div>
                <div class="panel panel-default bg-white border-white rounded-xl p-3" style="width: 420px">
                    <div class="panel-body text-center">
                        <h2>Password Required</h2>
                        <p>This Media Share is password protected.<br>
                            Please enter the password to continue.</p>
                        <base-password-input v-model="password" />
                        <div v-show="invalidLogin" class="help-block text-danger">
                            Invalid password, please try again.
                        </div>
                    </div>
                    <div class="panel-footer bg-white rounded-xl border-top-0 text-center">
                        <button class="btn btn-primary btn-lg rounded-xl px-5" @click="doLogin" :disabled="loggingIn">
                            <i v-if="loggingIn" class="fas fa-circle-notch fa-spin"></i>
                            {{ loggingIn ? 'Logging in...' : 'Continue' }}
                        </button>
                    </div>
                </div>
            </div>
        </layout>
    </div>
</template>

<script>
import Layout from './Layout';
import BasePasswordInput from '@/components/base/BasePasswordInput';

export default {
    name: 'Login',
    components: {
        Layout,
        BasePasswordInput,
    },
    data() {
        return {
            password: null,
            loggingIn: false,
            invalidLogin: false,
        }
    },
    methods: {
        doLogin() {
            this.loggingIn = true;

            const payload = {
                id: this.$route.params.id,
                password: this.password,
            };

            if (this.$route.query.e) {
                payload.email = this.$route.query.e;
            }

            this.$store
                .dispatch('app/login', payload).then((response) => {
                    this.loggingIn = false;
                    this.$store.dispatch('app/setData', response).then(() => {
                        this.$router.replace({name: 'home', params: {id: this.$route.params.id }});
                    });
                }).catch((error) => {
                    this.loggingIn = false;
                    if (error.response && error.response.status) {
                        const status = error.response.status;
                        if (status === 401) {
                            this.invalidLogin = true;
                        }
                    }
                });
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.media-share-login {

    .project-name {
        font-size: 1.8rem;
    }

    .panel {

        .panel-body {

            h2 {
                margin: 0 0 0.5rem 0;
                font-size: 1.8rem;
            }

            p {
                margin: 0 0 2rem 0;
                font-size: 1.6rem;
            }
        }

        .panel-footer {
            button {
                padding-top: 0.5rem;
                padding-bottom: 0.5rem;
            }
        }
    }
}
</style>
